var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        _vm._l(_vm.lookupList["TEAM_TYPE"], function (item, index) {
          return _c("el-tab-pane", {
            key: index,
            attrs: { label: item.name, name: item.code },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("organizationArchitecture.BoxWrap.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["IMPORT"] },
                    expression: "{pageName, list: ['IMPORT']}",
                  },
                ],
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function ($event) {
                        _vm.downloadExcel(
                          _vm.$t("organizationArchitecture.btn.exportText")
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("organizationArchitecture.btn.export"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    staticClass: "excel-upload-input",
                    staticStyle: { display: "inline" },
                    attrs: {
                      action: "",
                      "auto-upload": false,
                      "show-file-list": false,
                      accept: ".xlsx, .xls, .xlsm, .csv",
                      "on-change": _vm.uploadData,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", size: "mini" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.form.file
                              ? _vm.$t("organizationArchitecture.btn.resetFile")
                              : _vm.$t("organizationArchitecture.btn.import")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "row-key": "bizOrgInfoPk",
                border: "",
                "tree-props": { children: "children" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "bizOrgName",
                  label: _vm.$t("organizationArchitecture.table.role"),
                  width: "240",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "subLevel",
                  label: _vm.$t(
                    "organizationArchitecture.table.architectureLevel"
                  ),
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "structure-level",
                            class:
                              scope.row.subLevel === 1
                                ? "level-one"
                                : scope.row.subLevel === 2
                                ? "level-tow"
                                : "level-three",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.subLevel) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNo",
                  label: _vm.$t(
                    "organizationArchitecture.table.employeeNumber"
                  ),
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empName",
                  label: _vm.$t("organizationArchitecture.table.name"),
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "detail-model",
          attrs: {
            width: "900px",
            title: "导入结果",
            visible: _vm.isShowModel,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowModel = $event
            },
          },
        },
        [
          _c("Detail", {
            attrs: { "batch-id": _vm.excelBatchId, "is-error": _vm.isError },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.downloadResultExcel(
                        _vm.$t("organizationArchitecture.btn.exportText")
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.exportResult")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.isShowModel = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            "is-show": _vm.isShowProgress,
            "dialog-status": "导入进度",
            "show-close": _vm.showClose,
            "is-hide-footer": !_vm.showClose,
            "confirm-btn-text": _vm.confirmText,
            "save-item": _vm.handleClickConfirm,
            width: "1200px",
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowProgress = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowProgress = $event
            },
          },
        },
        [
          _vm.isShowProgress
            ? _c("Progress", {
                ref: "progress",
                attrs: {
                  "show-result": _vm.showResult,
                  "file-import-process-unique-code":
                    _vm.fileImportProcessUniqueCode,
                  "show-close": _vm.showClose,
                },
                on: {
                  "update:showClose": function ($event) {
                    _vm.showClose = $event
                  },
                  "update:show-close": function ($event) {
                    _vm.showClose = $event
                  },
                  error: _vm.handleError,
                  animeSuccess: _vm.handleEnd,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }